import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./Header.scss";
import Search from "./Search.jsx";
import * as helpers from "../helpers/helpers";
import FloatingMenu, { FloatingMenuItem } from "../helpers/FloatingMenu.jsx";
import { Item as MenuItem } from "rc-menu";
import Portal from "../helpers/Portal.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faCircleUser } from "@fortawesome/free-solid-svg-icons";
import "semantic-ui-css/semantic.min.css";
import mainConfig from "../configLoader";
import { WindowScroller } from "react-virtualized";

let ADMIN_URL = "";
let DB_RIGHTS_URL = "";




const feedbackTemplate = (
  url,
  xmin,
  xmax,
  ymin,
  ymax,
  centerx,
  centery,
  scale
) =>
  `${url}/?xmin=${xmin}&xmax=${xmax}&ymin=${ymin}&ymax=${ymax}&centerx=${centerx}&centery=${centery}&scale=${scale}`;
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoImage: "",
      userPanelPopupVisible: false,
      userName: "Meno Priezvisko",
    };
    helpers.waitForLoad("settings", Date.now(), 30, () => {
      var mainConfig = window.config;
      ADMIN_URL = mainConfig.adminUrl
      DB_RIGHTS_URL = mainConfig.dbRightsUrl
      this.setState({ logoImage: window.config.headerLogoImageName }, () => {
        window.emitter.emit("headerLoaded");
        helpers.addIsLoaded("header");
      });
    });
    // LISTEN FOR FEEDBACK
    window.emitter.addListener("feedback", () => this.onFeedbackClick());
    //console.log("window.config.useJWTAuth", window.config.useJWTAuth);  
    if (window.config.useJWTAuth) {
      const jwtToken = localStorage.getItem("jwtToken");
      if (!jwtToken) {
        window.location.href = "https://idp.bo.hmsp.sk/connect/authorize?response_type=code&client_id=1ad6115f-f952-4c84-8b1f-b2316de36ba8&scope=openid&response_mode=query&redirect_uri=https%3A%2F%2Fgis.bo.hmsp.sk%2Fsignin-oidc"; // Redirect to login page
      } else {
        window.userInfo = JSON.parse(localStorage.userInfo);
      }
    }
  }

  componentDidMount() {
    if (window.userInfo && window.config.useJWTAuth) {
      this.setState({ userName: window.userInfo.display_name });
    }
  }

  burgerButtonHandler() {
    helpers.waitForLoad("map", Date.now(), 30, () => {
      // EMIT A CHANGE IN THE SIDEBAR (IN OR OUT)

      helpers.addAppStat("Burger Button", "Click");

      // console.log(window.sidebarOpen);
      const elTable = document.getElementById("esp-blockAttable");
      if (window.sidebarOpen) {
        //  elTable.classList.remove("activeLeftPane");
        window.emitter.emit("setSidebarVisiblity", "CLOSE");
      } else {
        // elTable.classList.add("activeLeftPane");
        window.emitter.emit("setSidebarVisiblity", "OPEN");
      }
    });
  }

  onDotMenuClick = (evt) => {
    var evtClone = Object.assign({}, evt);
    const menu = (
      <Portal>
        <FloatingMenu
          key={helpers.getUID()}
          buttonEvent={evtClone}
          item={this.props.info}
          onMenuItemClick={this.onMenuItemClick}
          styleMode="left"
        >
          <MenuItem
            className="sc-floating-menu-toolbox-menu-item"
            key="sc-floating-menu-login"
          >
            <FloatingMenuItem imageName={"lock.png"} label="Login (Sample)" />
          </MenuItem>
        </FloatingMenu>
      </Portal>
    );
    ReactDOM.render(menu, document.getElementById("portal-root"));

    helpers.addAppStat("Header Dot Menu", "Click");
  };

  onMenuItemClick = (value) => {
    // helpers.showMessage("Coming Soon", "Coming Soon...");
    helpers.addAppStat("Header Dot Menu", value);
  };
  logOut = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("userInfo");
    window.location.href = "https://idp.bo.hmsp.sk/connect/endsession";
  }
  onFeedbackClick = () => {
    // APP STATS
    helpers.waitForLoad("settings", Date.now(), 30, () => {
      helpers.addAppStat("Feedback", "Click (Header)");

      const scale = helpers.getMapScale();
      const extent = window.map.getView().calculateExtent(window.map.getSize());
      const xmin = extent[0];
      const xmax = extent[1];
      const ymin = extent[2];
      const ymax = extent[3];
      const center = window.map.getView().getCenter();

      let feedbackUrl = feedbackTemplate(
        window.config.feedbackUrl,
        xmin,
        xmax,
        ymin,
        ymax,
        center[0],
        center[1],
        scale
      );
      if (
        window.config.mapId !== null &&
        window.config.mapId !== undefined &&
        window.config.mapId.trim() !== ""
      )
        feedbackUrl += "&MAP_ID=" + window.config.mapId;
      helpers.showURLWindow(feedbackUrl, false, "full");
    });
  };

  onUserPanelClick = () => {
    this.setState({ userPanelPopupVisible: !this.state.userPanelPopupVisible });
  };

  render() {
    let useradmin = "";
    let useradmin1 = <a href={DB_RIGHTS_URL} className="user-panel-item" target="blank">Upraviť editačné práva mapových vrstiev</a>;
    let useradmin2 = <a href={ADMIN_URL} className="user-panel-item" target="blank">Panel administrátora</a>;
    if (window.config.useJWTAuth && window.userInfo && window.userInfo.role_type === "administrator") {
      useradmin = [useradmin1, useradmin2];
    }
    return (
      <div className="header">
        <div id="header-left-box">
          <div
            id="sc-header-burger-button"
            onClick={this.burgerButtonHandler}
            tabIndex="2"
            onKeyPress={(evt) => {
              if (evt.key === "Enter") {
                this.burgerButtonHandler();
              }
            }}
          >
            {/* <img
              src={require("./images/burger-button.png")}
              alt="Burger Button"
              style={{ width: "1.6rem", marginLeft: -5, marginBottom: -5 }}
            /> */}
            <FontAwesomeIcon className="faBars-icon" icon={faBars} />
          </div>
          <div id="sc-header-bar-button">
            <img src={require("./images/bar-button.png")} />
          </div>
          <div id="sc-header-bar-logo">
            <img
              src={
                this.state.logoImage === "" ||
                  this.state.logoImage
                    .toString()
                    .substring(0, 4)
                    .toUpperCase() === "HTTP"
                  ? this.state.logoImage
                  : require("./images/" + this.state.logoImage)
              }
            // alt="Header Logo"
            />
          </div>
          <div className="logo-name" style={{color: "#6d95b8"}}>GIS<br/>Hydromeliorácie š.p.</div>
        </div>
        <div id="header-right-box">
          <div id="sc-header-search-container">
            <Search options={this.props.options} />
          </div>
          <div id="sc-header-user-panel">
            <div
              className={
                this.state.userPanelPopupVisible
                  ? "ui flowing download basic popup bottom center transition user-panel-popup visible"
                  : "ui flowing download basic popup bottom center transition user-panel-popup hidden"
              }
              style={{
                width: "200px",
                top: "40px",
                boxShadow: "none",
                borderRadius: "0",
              }}
            >
              <div className="user-panel-item-container">
                {useradmin}
                <a onClick={this.logOut} className="user-panel-item" style={{ cursor: "pointer" }}>Odhlásiť sa</a>
              </div>
            </div>

            <div
              id="user-panel-container"
              onClick={this.onUserPanelClick}
              style={{
                display: window.config.hideUserPanel ? "none" : "flex",
              }}
            >
              <div className="user-icon">
                <FontAwesomeIcon className="faUser-icon" icon={faCircleUser} />
              </div>
              <div className="user-name">{this.state.userName}</div>
            </div>

          </div>
          {
            window.config.showHelpButtonInsteadOfFeedback ? (
              <div className="sc-header-help-container">
                <div
                  className="sc-header-help-btn"
                  onClick={() =>
                    helpers.showURLWindow(window.config.helpUrl, false, "full")
                  }
                  title="Používateľská príručka"
                >
                  ?
                </div>
              </div>
            ) : (
              <div></div>
            )
            //   (
            //     <div
            //       className="sc-header-feedback-container"
            //       title="Feedback"
            //       onClick={this.onFeedbackClick}
            //     >
            //       <img
            //         style={{ marginTop: "5px" }}
            //         src={require("./images/feedback.png")}
            //         alt="feedback"
            //       />
            //       Feedback
            //     </div>
            //   )
          }

          {/* <div className="sc-header-dot-menu-container" onClick={this.onDotMenuClick}><img className="sc-header-dot-menu-img" src={images['vertical-dot-menu.png']} alt="dots"></img></div> */}
        </div>
      </div>
    );
  }
}
//
export default Header;
